import * as R from "ramda"
import { getStoreKeyByName } from "../Steps";

const nameStoreFormValue = getStoreKeyByName('info')

const informationFormData = {
  collectInfo: [
    { label: 'Usage Data', value: 'Usage Data', disabled: false, custom: false },
    { label: 'Name', value: 'Name', disabled: false, custom: false },
    { label: 'Email', value: 'Email', disabled: false, custom: false },
    { label: 'Mobile Number', value: 'Mobile Number', disabled: false, custom: false },
    { label: 'Social Media Profile', value: 'Social Media Profile', disabled: false, custom: false },
    { label: 'Date of Birth', value: 'Date of Birth', disabled: false, custom: false },
    { label: 'Work Address', value: 'Work Address', disabled: false, custom: false },
    { label: 'Home Address', value: 'Home Address', disabled: false, custom: false },
    { label: 'Payment Information', value: 'Payment Information', disabled: false, custom: false },
  ],

  wayCollect: [
    { label: 'User registration / Forms', value: 'User registration / Forms', disabled: false, custom: false },
    { label: 'When user browses the website', value: 'When user browses the website', disabled: false, custom: false },
    { label: 'External sources', value: 'External sources', disabled: false, custom: false },
  ]
}


const defaultValue = {
  collectInfo: ['Usage Data'],
  wayCollect: ['User registration / Forms'],
  collectDays: '',
}

export const informationFormState = set =>  ({
  informationFormData: informationFormData,
  resetInformationFormData: () => set({ informationFormData: informationFormData  }),
  addInformationFormDataByKey: (key, item) => (set(state => {
    const newValue = [...state.informationFormData[key], item ];
    return { informationFormData:  { ...state.informationFormData, [key]: newValue } }
  })),
  removeInformationFormDataByKey: (key,item) => set(state => {
    const compareFunc = option => option.value !== item.value
    const newValue = R.filter(compareFunc, state.informationFormData[key])

    return { informationFormData:  { ...state.informationFormData, [key]: newValue } }
  }),

  [nameStoreFormValue]:  defaultValue,
  resetInformationFormValue: () => set({ [nameStoreFormValue]: defaultValue  }),
  setInformationFormValue: value => set({ [nameStoreFormValue]: value}),
  changeInformationFormValue: (name, value) =>
    set(state => ({ [nameStoreFormValue]: {...state[nameStoreFormValue], [name]: value } })),
})